import { createFileRoute } from '@tanstack/react-router'
import { ApiTokenSection } from '@/features/settings/token'
import { ThemeSection } from '@/features/settings/theme'
import { AboutSection } from '@/features/settings/about'

function SettingsPage() {
  return (
    <div className="flex flex-col gap-6 px-4 py-6 md:px-6 lg:px-8 mx-auto w-full max-w-3xl">
      <div className="space-y-1">
        <h1 className="text-xl font-semibold tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground">
          Authentication, appearance, and platform info.
        </p>
      </div>
      <ApiTokenSection />
      <ThemeSection />
      <AboutSection />
    </div>
  )
}

export const Route = createFileRoute('/settings/')({
  component: SettingsPage,
})
